import "core-js/stable";
import "regenerator-runtime/runtime";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import { toggleBodyClass } from './_class/_toggle';
import './_add-index.js';

document.querySelector('.menu-icon').addEventListener('click', toggleBodyClass('menu-open'));
// document.querySelector('.menu-close').addEventListener('click', toggleBodyClass('menu-open'));
document.querySelector('.site-header__open-menu').addEventListener('click', toggleBodyClass('menu-open'));

import ScrollOut from "scroll-out";

function setScrollOut(){
  ScrollOut({
    targets: ".site-footer .address__reception-hours",
    onShown: function (element, ctx, scrollingElement) {
      document.body.classList.add('site-footer-in');
    },
    onHidden: function (element, ctx, scrollingElement) {
      document.body.classList.remove('site-footer-in');
    },
  });
  ScrollOut({
    targets: "body",
    offset: window.screen.height
  });
  ScrollOut({
    targets: ".site-content",
    offset: 400,
    onShown: function (element, ctx, scrollingElement) {
      document.body.classList.add('site-main-in');
    },
    onHidden: function (element, ctx, scrollingElement) {
      document.body.classList.remove('site-main-in');
    },
  });
}
setScrollOut();
